import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  class: "flex-body"
};
const _hoisted_3 = {
  class: "text-left"
};
const _hoisted_4 = {
  class: "localized-text"
};
const _hoisted_5 = {
  class: "list"
};
const _hoisted_6 = {
  class: "assembly-image"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "desc-button"
};
const _hoisted_9 = {
  class: "button-col"
};
const _hoisted_10 = {
  class: "wikaButtonConf",
  "data-colour": "white",
  "data-no-border": "",
  "data-type": "button"
};
const _hoisted_11 = {
  class: "assembly-image"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "desc-button"
};
const _hoisted_14 = {
  class: "button-col"
};
const _hoisted_15 = ["data-colour", "onClick"];
const _hoisted_16 = ["data-colour"];
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { openFullLoading } from "@/utils/tools";
import { useI18n } from "vue-i18n";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
// import { isCodingCertificate } from "../utils/responseUtil";
export default /*@__PURE__*/_defineComponent({
  __name: 'OptionalCertificateDialog',
  props: /*@__PURE__*/_mergeModels({
    showClose: {
      type: Boolean,
      default: false
    }
  }, {
    "modelValue": {
      type: Boolean
    },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const model = _useModel(__props, "modelValue");
    const store = useConfiguratorStore();
    const {
      t
    } = useI18n();
    const currentSelectedCertificates = ref([]);
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const optionalCurrentCoding = computed(() => {
      return store.apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding.filter(item => item.CodeTypeId != "LABEL" && item.Category == "Certificates" && item.Optional == "Yes" && store.allowOptionalModel == true && !item?.Originators?.some(org => org.CodeTypeId !== store.lastSelectedcodeType || org.CriteriaId !== store.getLastselectedCriteriaOption?.CriteriaId || org.OptionId !== store.getLastselectedCriteriaOption?.OptionId)) ?? [];
    });
    const nonOptionalCurrentCoding = computed(() => {
      return store.apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding.filter(item => item.CodeTypeId != "LABEL" && item.Category == "Certificates" && item.Optional == "No" && store.allowOptionalModel == true && !item?.Originators?.some(org => org.CodeTypeId !== store.lastSelectedcodeType || org.CriteriaId !== store.getLastselectedCriteriaOption?.CriteriaId || org.OptionId !== store.getLastselectedCriteriaOption?.OptionId)) ?? [];
    });
    function onOpen() {
      currentSelectedCertificates.value = store.getSelectedCertificateGroup.items.map(item => item.codeTypeId);
    }
    onMounted(() => {
      onOpen();
    });
    function isSelected(item) {
      return currentSelectedCertificates.value.includes(item.CodeTypeId);
    }
    async function confirmSelection() {
      const storedCertificateCodes = store.getSelectedCertificateGroup.items.map(item => item.codeTypeId);
      const addedSelections = currentSelectedCertificates.value.filter(code => !storedCertificateCodes.includes(code));
      const removedSelections = storedCertificateCodes.filter(code => !currentSelectedCertificates.value.includes(code));
      addedSelections.forEach(store.addSelectedCertificate);
      const loading = openFullLoading(false, t("text.loading"));
      for (const removedSelection of removedSelections) {
        const element = optionalCurrentCoding.value.find(current => current.CodeTypeId === removedSelection);
        if (element) {
          await store.resetAssembly(element.CodeTypeId);
        }
        store.removeSelectedCertificate(removedSelection);
      }
      loading.close();
      model.value = false;
      useConfiguratorStore().setcertificateSelectorOpen(null);
      const overlay = document.getElementById("overlay");
      if (overlay) {
        overlay.scrollTo({
          behavior: "smooth",
          top: 0
        });
      }
      eventBus.emit("selectedCertificateEmpty", store.getSelectedCertificateGroup.items.length === 0);
    }
    function switchOptionalCertificate(item) {
      if (currentSelectedCertificates.value.includes(item.CodeTypeId)) {
        currentSelectedCertificates.value = currentSelectedCertificates.value.filter(code => code !== item.CodeTypeId);
      } else {
        currentSelectedCertificates.value.push(item.CodeTypeId);
      }
    }
    function getImageUrl(codeTypeId) {
      return store.getImageByCodeTypeId(codeTypeId)?.rs_w90_h90_image ?? useAdditionalAttrStore().getDataConfig.thumbnailsPlaceholderUrl;
    }
    const placeholderImage = ref("");
    placeholderImage.value = require(process.env.VUE_APP_PLACEHOLDER_IMAGE);
    eventBus.on("resetSelectedOptionalCertificate", () => {
      currentSelectedCertificates.value = [];
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return optionalCurrentCoding.value.length > 0 ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => model.value = $event),
        "show-close": props.showClose,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true,
        onVisibleChange: onOpen,
        visible: onOpen,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => onOpen = $event),
        onOpen: onOpen
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.dialog.optionalCertificate")), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("text.dialog.optionalCertificateSummary")), 1)]), _createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonOptionalCurrentCoding.value, item => {
          return _openBlock(), _createElementBlock("li", {
            class: "non-optional-item",
            key: item.CodeTypeId
          }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_image, {
            class: "optional-assembly-image",
            src: getImageUrl(item.CodeTypeId),
            fit: "contain"
          }, {
            error: _withCtx(() => [_createElementVNode("img", {
              width: "60px",
              height: "60px",
              style: {
                "opacity": "0.5"
              },
              src: placeholderImage.value,
              alt: "Placeholder"
            }, null, 8, _hoisted_7)]),
            _: 1
          }, 8, ["src"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("h4", null, _toDisplayString(item.CodeTypeName), 1), _createElementVNode("p", null, _toDisplayString(item.Description), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("button.dialog.selected")), 1)])]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionalCurrentCoding.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.CodeTypeId
          }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_image, {
            class: "optional-assembly-image",
            src: getImageUrl(item.CodeTypeId),
            fit: "contain"
          }, {
            error: _withCtx(() => [_createElementVNode("img", {
              width: "60px",
              height: "60px",
              style: {
                "opacity": "0.5"
              },
              src: placeholderImage.value,
              alt: "Placeholder"
            }, null, 8, _hoisted_12)]),
            _: 1
          }, 8, ["src"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("h4", null, _toDisplayString(item.CodeTypeName), 1), _createElementVNode("p", null, _toDisplayString(item.Description), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
            class: "wikaButtonConf",
            "data-colour": isSelected(item) ? 'white' : 'blue',
            "data-no-border": "",
            "data-type": "button",
            onClick: $event => switchOptionalCertificate(item)
          }, [_createElementVNode("i", {
            class: _normalizeClass(['iconfont', isSelected(item) ? 'icon-status-error' : 'icon-plus-circle-fill'])
          }, null, 2), _createTextVNode(" " + _toDisplayString(isSelected(item) ? _ctx.$t("button.dialog.optionalAssemblyDetach") : _ctx.$t("button.dialog.optionalAssemblyAttach")), 1)], 8, _hoisted_15)])]);
        }), 128))]), _createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": currentSelectedCertificates.value.length < 1 ? 'white' : 'blue',
          "data-no-border": "",
          "data-type": "button",
          onClick: confirmSelection
        }, _toDisplayString(_ctx.$t("button.dialog.optionalAssemblyConfirm")), 9, _hoisted_16)])])]),
        _: 1
      }, 8, ["modelValue", "show-close"])) : _createCommentVNode("", true);
    };
  }
});